import engine from "../../images/qlik-sense/qlik_associative_engine.png";
import block3 from "../../images/qlik-sense/Qlik_dashboard_bureau_man.jpg";
import qlikviewvssense from "../../images/qlik-sense/qlikviewtoqliksense2x.png"
import ritualsVideo from "../../images/qlik-sense/rituals-filmpje-2015.mp4"
import ritualsVideoPoster from "../../images/qlik-sense/hans-rituals.jpg"
import qlikDashboard from "../../images/qlik-sense/qlik-sense-1x.png"

export default {
    pageData: {
        meta: {
            title: "Wij kennen de kracht van informatie",
            description: "Met de juiste informatie functioneert uw bedrijf efficienter, en bent u de concurrentie een stap voor."
        },
        jumbotron: {
            title: "Qlik",
            subtitle: "Lead with data",
            callToAction: "",
            callToActionLink: "",
        },
        intro: {
            image: {
                image: qlikDashboard,
                alt: "Qlik Sense dashboard"
            },
            header: "",
            custom: "Op zoek naar een BI oplossing? </br>Dan moet je zeker met Qlik Sense kennismaken!",
            text: ""
        },
        innovatief: {
            header: "Innovatief, modern en eenvoudig in gebruik",
            textLeft: "De visie van Qlik is een zogenaamde “data geletterde wereld”, waarin mensen, organisaties complexe bedrijfsuitdagingen oplossen met behulp van data." +
                "<p>Al meer dan 10 jaar ondersteunt DDC organisaties met de inzet van Qlik software waarmee organisaties nieuwe inzichten uit hun data halen ter verbetering van hun bedrijfsprestaties; <span class='italic'>Achieve more with data</span>. Qlik ontwikkelt sinds 1993 visuele analytische software met de komst van QlikView voor guided analytics. Inmiddels is daar Qlik Sense als modern platform bij gekomen voor data visualization en discovery.</p>" +
                "<p>Qlik heeft een positie verworven als belangrijke benchmark voor andere BI & analytics-platforms. Qlik staat dan ook al jarenlang in het leiderskwadrant van Gartner. Met zijn unieke associatieve engine voor analyses, geavanceerde augmented intelligence en een hoogwaardig platform, motiveer je iedereen binnen je organisatie om elke dag data te analyseren en betere beslissingen te nemen.</p>",
            textRight: ""
        },
        engine: {
            image: {
                image: engine,
                alt: "Qlik Sense Associative Engine"
            },
            header: "Associative Engine",
            text: "In de kern maakt het Qlik platform gebruik van een unieke wijze waarop data wordt samengebracht en getoond, de in-memory “associatieve engine”." +
                "<p>Qlik toont wat wel, gedeeltelijk en niet is geassocieerd met een selectie. Hierdoor blijft alle data toegankelijk voor analyse en vervolgvragen. In de Qlik community wordt dit de “power of gray” genoemd, omdat grijs de kleur is van data die niet aan je selectie is gerelateerd en juist daar het antwoord op je vraag kan liggen. Dit maakt Qlik een echte “data analytics”-oplossing.</p>" +
                "<p>Andere BI platforms visualiseren data op basis van een hiërarchisch datamodel. Bij elke selectie verdwijnt daardoor echter een stuk van de data welke niet meer toegankelijk is voor analyse. Hierdoor mis je data om bepaalde vragen te beantwoorden. Dit maakt andere platforms uitsluitend een “data visualisatie”-oplossing.</p>" +
                "<p>Dit is een essentieel verschil, wat Qlik onderscheid van andere BI software leveranciers. We laten je deze unieke eigenschap graag even zien tijdens een (online) demo.</p>"
        },
        enterprise: {
            header: "Qlik Sense Enterprise SaaS",
            image: {
                image: block3,
                alt: "Qlik Sense animation"
            },
            text: "Wil je zorgeloos gebruik maken van Qlik Sense Enterprise zonder zorgen over servers, hosting en infrastructuur? Bij Qlik Sense Enterprise SaaS is Qlik verantwoordelijk voor het hosten en beheer van de software. De storage capaciteit is inbegrepen in de licentie. Kortom, je verliest geen tijd en kunt direct aan de slag." +
                "<p>Qlik Sense Enterprise SaaS biedt:</p>" +
                "<ul>" +
                "<li>De kracht van Qlik Sense Enterprise in de cloud</li>" +
                "<li>Gehost in een Europees data center</li>" +
                "<li>ISO 27001 en SOC 2 Certified</li>" +
                "<li>GDPR compliant</li>" +
                "<li>99,9% uptime commitment</li>" +
                "<li>Onbeperkte storage capaciteit en aantal applicaties</li>" +
                "<li>Individuele applicatie grote is maximaal 5 GB</li>" +
                "</ul>"
        },
        nprinting: {
            header: "Qlik Nprinting",
            textLeft: "NPrinting maakt het mogelijk om gepersonaliseerde en interactieve rapportages op te stellen, in te roosteren en te verspreiden naar mensen binnen en buiten je organisatie. De visueel aantrekkelijke rapportages worden opgesteld op basis van gegevens uit een of meerdere Qlik applicaties. De rapportages kunnen gegenereerd worden in diverse formats, zoals Microsoft Office, PixelPerfect, PDF en HTML. Nprinting maakt het daarmee mogelijk de kracht van Qlik verder binnen en buiten de organisatie te verspreiden." +
                "<p>Organisaties kunnen hierdoor aanzienlijke kosten besparen door andere rapportage distributie oplossingen van de hand te doen.</p>",
            textRight: "Met NPrinting kan je de juiste rapportages delen met de juiste personen, zowel ad-hoc als gepland. Op basis van specifieke filters zoals e-mailadressen en afdelingen kunnen ontvangers worden geïdentificeerd. Daarnaast zijn verschillende mogelijkheden voorhanden om de rapportages te distribueren zoals per e-mail, publiceren op een website of opslaan in een netwerk directory. NPrinting kan ook automatisch een rapport genereren wanneer aan specifieke voorwaarden (triggers/alerts) wordt voldaan."
        },
        datatransfer: {
            header: "Qlik DataTransfer",
            image: {
                image: block3,
                alt: "Qlik Sense animation"
            },
            text: "Bij veel organisaties die gebruik willen gaan maken van de cloud staan de databronnen nog on-premise. Qlik Data Transfer maakt het mogelijk om deze data veilig en efficiënt naar Qlik Sense Enterprise SaaS te sturen. Deze tool maakt daarom de overstap naar SaaS mogelijk voor bestaande QlikView en Sense klanten die hun omgeving on-premise hebben staan."
        },
        connectors: {
            headerLeft: "Qlik Connectors",
            headerRight: "Qlik SAP NetWeaver connector",
            textLeft: "Met Qlik Sense kun je verbinding maken met jouw gegevens (ongeacht waar deze zijn opgeslagen), met een breed scala aan Qlik-connectoren en andere typen gegevensverbindingen." +
                "<p>Via een ODBC koppeling, RESTful API of web connector kan Qlik Sense met praktisch iedere databron verbonden worden.</p>",
            textRight: "De Qlik SAP NetWeaver connector maakt het mogelijk voor QlikView en Qlik Sense om efficiënt data in te laden van SAP NetWeaver.  De informatie kan in verschillende onderdelen van de SAP architectuur opgeslagen staan zoals SAP BI/BW, SAP ERP of CRM systeem." +
                "<p>Standaard is de Qlik connector voor gebruik met SAP NetWeaver niet beschikbaar als gegevensverbinding in Qlik DataTransfer. U kunt de connector echter wel toevoegen aan Qlik DataTransfer.</p>"
        },
        qlikview: {
            header: "QlikView",
            image: {
                image: qlikviewvssense,
                alt: "Qlik Sense vs QlikView"
            },
            text: "QlikView is de klassieke oplossing voor ‘guided analytics’ waarmee Qlik in 1993 op de markt kwam. Een QlikView ontwikkelaar bouwt een interactief dashboard voor gebruikers met analysedoeleinden. QlikView heeft in de basis dezelfde associatieve engine als ook in Qlik Sense wordt gebruikt en kenmerkt zich als een zeer uitgebreid product waarbij iedere pixel op het scherm aangepast kan worden. Het platform heeft verder een grote enthousiaste gebruikers community." +
                "<p>Om te voldoen aan de hedendaagse self-service behoeften en mogelijkheden om Qlik analyses binnen andere platformen toe te passen, heeft Qlik in 2014 Qlik Sense op de markt gebracht. Nieuwe klanten starten over het algemeen met Qlik Sense. En inmiddels zijn ook veel QlikView klanten overgestapt naar Qlik Sense of hebben zij een combinatie van de twee.</p>",
        },
        klanten: {
            header: "Klanten",
            image: {
                image: ritualsVideoPoster,
                alt: "DDC Qlik Rituals"
            },
            text: "DDC heeft sinds 2009 al veel organisaties geholpen met de inzet van Qlik software. Een aantal van deze klanten zijn:" +
                "<ul>" +
                "<li>Rituals</li>" +
                "<li>Kamera Express</li>" +
                "<li>Philips</li>" +
                "<li>Kyocera</li>" +
                "<li>HTM</li>" +
                "<li>Koninklijke Mosa</li>" +
                "<li>Dr Jekill & Mr Hyde</li>" +
                "<li>Groenhuysen</li>" +
                "</ul>",
            video: ritualsVideo
        },
        contactList: [
            'Christian Pilon', 'Hans Giesbers'
        ]
    },
}
